import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FileSpreadsheet } from "lucide-react";

const py = (v) => Number(v || 0).toLocaleString("es-PY", { maximumFractionDigits: 0 });

export const CargaExcel = ({ onCambio }) => {
  const [res, setRes] = useState({});
  const [ocupado, setOcupado] = useState("");
  const subir = async (tipo, file) => {
    if (!file) return;
    setOcupado(tipo);
    const fd = new FormData(); fd.append("tipo", tipo); fd.append("file", file);
    try { const r = await api.post("/carga-central/subir-excel", fd); setRes((x) => ({ ...x, [tipo]: r.data })); toast.success(tipo === "lineas" ? `Líneas: ${r.data.filas} filas · ${r.data.excluidos} excluidos por "NO TENER EN CUENTA"` : `Pagarés de terceros: stock ${r.data.stock}`); onCambio?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "No se pudo leer el Excel"); }
    finally { setOcupado(""); }
  };
  const Caja = ({ tipo, titulo, det }) => (
    <label className="cc-lista flex flex-col gap-2 cursor-pointer" style={{ padding: "12px 18px", borderStyle: "dashed" }} data-testid={`cc-excel-${tipo}`}>
      <span className="text-sm font-semibold flex items-center gap-2"><FileSpreadsheet className="h-4 w-4" style={{ color: "#007336" }} /> {titulo} <span className="cc-pill" style={{ fontSize: 11 }}>.xlsx</span></span>
      <span className="text-xs" style={{ color: "#5B6858" }}>{det}</span>
      <input type="file" accept=".xlsx" className="text-xs" disabled={Boolean(ocupado)} onChange={(e) => subir(tipo, e.target.files?.[0])} data-testid={`cc-excel-input-${tipo}`} />
      {ocupado === tipo && <span className="text-xs">Leyendo…</span>}
      {res[tipo] && tipo === "lineas" && <span className="text-xs font-semibold" data-testid="cc-excel-lineas-res">{res[tipo].filas} filas · {res[tipo].excluidos} excluidos ("NO TENER EN CUENTA": {res[tipo].no_tener}) · quedan {res[tipo].quedan} · corte {res[tipo].corte}</span>}
      {res[tipo] && tipo === "pagares_terceros" && <span className="text-xs font-semibold" data-testid="cc-excel-terceros-res">{res[tipo].filas} filas · stock {res[tipo].stock} (US$ {py(res[tipo].stock_usd)}) · vencidos <b style={{ color: "#B8402A" }}>{res[tipo].vencidos} (US$ {py(res[tipo].vencidos_usd)})</b></span>}
    </label>
  );
  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid="cc-excel">
      <Caja tipo="lineas" titulo="Líneas de crédito (Excel)" det='Hoja "LISTADO DE LINEAS DE CREDITO" por nombre de columna + hoja "NO TENER EN CUENTA" (actualiza "Clientes que no computan").' />
      <Caja tipo="pagares_terceros" titulo="Pagarés de terceros (Excel)" det="Reemplaza el stock anterior. Stock = portador coordinador (no cofres ni el propio cliente)." />
    </div>
  );
};
